import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { CajaInfo } from "./cajainfo";
import { DestinosSucusal } from "./destinos/destinossucursal";
import { DestinosCaja } from "./destinos/destinoscaja";
import { EstatusCargaDescarga } from "./estatus";
import { Lector } from "./lector";

export interface Props {
    value: models.CargaDescargaCajaRutaDto;
}

const FinalizarButton = kea.defaultProps(kea.Button, { children: "Finalizar", iconClass: fa("check"), style: "success" });
const ImprimirButton = kea.defaultProps(kea.Button, { children: "Imprimir manifiesto", iconClass: fa("print"), style: "info" });
const CargaAdministradoresButton = kea.defaultProps(kea.Button, { children: "Imprimir reporte carga adminsitradores", iconClass: fa("print"), style: "warning" });

class CargaDescargaForm extends React.PureComponent<Props> {
    onRegresar = async () => {
        await history.go("../");
    }

    onFinalizar = async () => {
        if (await kea.yesno("¿Finalizar proceso?")) {
            await resources.CargaDescarga.FinalizarCargaDescarga(this.props.value.IdRegistro);
            await kea.message("Proceso finalizado correctamente", "", "success");
            history.go("../");
        }
    }

    onImprimir = async () => {
        const data = await resources.CargaDescarga.ReporteManifiesto(this.props.value.IdRegistro);
        kea.printPdf(data);
    }

    render() {
        const x = this.props.value;
        const tipo = models.TipoCargaDescarga[x.Tipo];
        const idCaja = x.IdCajaRuta;

        return (
            <div>
                <kea.Title titulo={`${tipo} de caja de ruta`}
                    onRegresar={this.onRegresar} >
                    {
                        (x.Status == models.StatusCargaDescarga.EnProceso) &&
                        <FinalizarButton onClick={this.onFinalizar} />
                    }
                    <ImprimirButton onClick={this.onImprimir} />
                </kea.Title >
                {kea.autogrid(2, [
                    <kea.Number label="Folio:" value={x.Folio} readonly={true} />
                ])}
                {kea.autogrid(6, [
                    <CajaInfo value={x} />
                    //,x.Tipo == models.TipoCargaDescarga.Carga ? <DestinosSucusal value={idCaja} /> : <DestinosCaja value={idCaja} />
                ])}

                <Lector idCargaDescarga={x.IdRegistro} />
                <EstatusCargaDescarga value={x.IdRegistro} />
            </div>
        )
    }
}

export const CargaDescargaFormRx = componentToRx(CargaDescargaForm);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargacajaruta/edit/form.tsx